module.exports = __webpack_public_path__ + "static/media/home.3272dfb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/home.png
// module id = 132
// module chunks = 0